import { EVENT_ENUM } from '@/constants/global';

export const TASK_OVERFLOW = 74;
export const ROUTE_USER_OVERFLOW = 53;
export const ROUTE_USER_TASK_OVERFLOW = 231;

export enum TASK_STATUS {
	DONE = 'DONE',
	SKIPPED = 'SKIPPED',
	TO_DO = 'TO_DO', // Assigned
	UNASSIGNED = 'UNASSIGNED',
	UNCOMPLETED = 'UNCOMPLETED',
	IN_PROGRESS = 'IN_PROGRESS',
}

export const COLOR_STATUS_MAP: Record<TASK_STATUS, string> = {
	DONE: '#32A960',
	TO_DO: '#329AFF',
	SKIPPED: '#8C8C8C',
	UNASSIGNED: '#FBBC4C',
	UNCOMPLETED: '#FF4D4E',
	IN_PROGRESS: '#161EF7',
};

type StatusTags = {
	color: string;
	labelKey: string;
	ribbon: string;
};
export const TASK_STATUS_TAGS: Record<TASK_STATUS, StatusTags> = {
	DONE: { color: 'success', labelKey: 'doneTask', ribbon: COLOR_STATUS_MAP.DONE },
	TO_DO: { color: 'processing', labelKey: 'assigned', ribbon: COLOR_STATUS_MAP.TO_DO },
	SKIPPED: { color: 'default', labelKey: 'skipped', ribbon: COLOR_STATUS_MAP.SKIPPED },
	UNASSIGNED: { color: 'warning', labelKey: 'unassigned', ribbon: COLOR_STATUS_MAP.UNASSIGNED },
	UNCOMPLETED: { color: 'error', labelKey: 'uncompletedTasks', ribbon: COLOR_STATUS_MAP.UNCOMPLETED },
	IN_PROGRESS: { color: 'processing', labelKey: 'inProgress', ribbon: COLOR_STATUS_MAP.IN_PROGRESS },
};

export const YEAR_MONTH_DAY_FORMAT = 'YYYY-MM-DD';
export const DAY_MONTH_YEAR_FORMAT = 'DD-MM-YYYY';
export const YEAR_MONTH_DAY_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss.SSS';
export const UTC_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';

// Map limits to avoid it from navigating into blank tiles
export const MAP_BOUNDS_EDGES = {
	north: 85,
	south: -85,
	east: 180,
	west: -180,
};

export const MAP_RESTRICTED_ZOOM = {
	minZoom: 3,
	maxZoom: 20,
};

export const MultimediaQueueStatus: Record<string, { label: string; color: string }> = {
	'1': { label: 'videoRequested', color: 'blue' },
	'100': { label: 'deviceReceivedRequest', color: 'blue' },
	'110': { label: 'deviceReceivedRequest', color: 'blue' },
	'101': { label: 'deviceRefusedRequest', color: 'red' },
	'111': { label: 'deviceRefusedRequest', color: 'red' },
	'102': { label: 'deviceBusy', color: 'red' },
	'112': { label: 'deviceBusy', color: 'red' },
	'200': { label: 'devicePreparedVideo', color: 'blue' },
	'210': { label: 'devicePreparedVideo', color: 'blue' },
	'201': { label: 'deviceCannotPrepareVideo', color: 'red' },
	'211': { label: 'deviceCannotPrepareVideo', color: 'red' },
	'300': { label: 'deviceIsUploadingVideo', color: 'blue' },
	'310': { label: 'deviceIsUploadingVideo', color: 'blue' },
	'301': { label: 'videoUploadSuccess', color: 'green' },
	'311': { label: 'videoUploadSuccess', color: 'green' },
	'302': { label: 'videoUploadFail', color: 'red' },
	'312': { label: 'videoUploadFail', color: 'red' },
	'313': { label: 'videoUploadFail', color: 'red' },
	'323': { label: 'videoUploadFail', color: 'red' },
	'408': { label: 'requestTimeout', color: 'red' },
	'-1': { label: 'videoUploadFail', color: 'red' },
};

export const EventTranslationMap: Record<number, string> = {
	[EVENT_ENUM.EYES_CLOSE_DETECTION]: 'eyesCloseDetection',
	[EVENT_ENUM.YAWNING_DETECTION]: 'yawningDetection',
	[EVENT_ENUM.DISTRACTION_DETECTION]: 'distractionDetection',
	[EVENT_ENUM.SMOKING_DETECTION]: 'smokingDetection',
	[EVENT_ENUM.PHONE_USE_DETECTION]: 'phoneUseDetection',
	[EVENT_ENUM.DRIVER_ABNORMAL_DETECTION]: 'driverAbnormalDetection',
	[EVENT_ENUM.IR_BLOCKING_DETECTION]: 'irBlockingDetection',
	[EVENT_ENUM.SEATBELT_UNFASTENED_DETECTION]: 'seatbeltUnfastenedDetection',
	[EVENT_ENUM.FORWARD_COLLISION_WARNING_ADAS]: 'forwardCollisionWarningAdas',
	[EVENT_ENUM.PEDESTRIAN_COLLISION_WARNING_ADAS]: 'pedestrianCollisionWarningAdas',
	[EVENT_ENUM.HEADWAY_MONITORING_WARNING_ADAS]: 'headwayMonitoringWarningAdas',
	[EVENT_ENUM.LANE_DEPARTURE_WARNING_ADAS]: 'laneDepartureWarningAdas',
	[EVENT_ENUM.BLIND_SPOT_DETECTION]: 'blindSpotDetection',
};
